import _ from 'lodash';
import { AdjustmentType } from 'enums';
import { AdjustmentDetail, PaymentDetail } from 'types';

const PricingAdjustmentTypes = [AdjustmentType.Pricing, AdjustmentType.SpecialPricing];

export default function useAdjustmentTotal(adjustments: AdjustmentDetail[]): (type: AdjustmentType) => number {

    const paymentDetails: PaymentDetail[] = adjustments as PaymentDetail[];
    const isPaymentDetail = () => !_.isEmpty(adjustments) && 'discountPaymentAmount' in adjustments[0];
    return (type: AdjustmentType) => {
        switch (type) {
            
            case AdjustmentType.Discount:
                return isPaymentDetail() 
                    ? adjustments.filter((adjustment) => (adjustment as PaymentDetail).discountPaymentAmount != 0).reduce((sum, adjustment) => sum + (adjustment as PaymentDetail).discountPaymentAmount, 0)
                    : adjustments.filter(adjustment => adjustment.adjustmentTypeId === type).reduce((sum, adjustment) => sum + adjustment.adjustmentAmount, 0);

            case AdjustmentType.Pricing:
            case AdjustmentType.SpecialPricing:
                return adjustments.filter((adjustment) => PricingAdjustmentTypes.includes(adjustment.adjustmentTypeId))
                    .reduce((sum, adjustment) => sum + adjustment.adjustmentAmount, 0) || 0;

            case AdjustmentType.Quantity:
                return adjustments.filter(adjustment => adjustment.adjustmentTypeId === type)
                    .reduce((sum, adjustment) => sum + adjustment.adjustmentAmount, 0);

            case AdjustmentType.Invoice:
                return paymentDetails.filter((detail) => detail.dotPriceAdjustment !== 0 || detail.dotQuantityAdjustment !== 0)
                .reduce((sum, detail) => sum + detail.dotPriceAdjustment + detail.dotQuantityAdjustment, 0);

            default:
                return adjustments.filter((adjustment) => adjustment.adjustmentTypeId === type)
                        .reduce((sum, adjustment) => sum + adjustment.adjustmentAmount, 0) || 0;
        };
    };
}